import { createContext, useContext } from 'react';

export interface AgentMessageContextValue {
  isLastMessage: boolean;
  isStreaming: boolean;
  onUserPrompt: (message: string) => void;
}

const defaultValue: AgentMessageContextValue = {
  isLastMessage: false,
  isStreaming: false,
  onUserPrompt: () => {}
};

const AgentMessageContext = createContext<AgentMessageContextValue>(defaultValue);

/** Context for agent markdown links rendered inside a chat message bubble. */
export function useAgentMessageContext() {
  return useContext(AgentMessageContext);
}

export default AgentMessageContext;
